module.exports = __webpack_public_path__ + "img/iStock-626967668.79e485ba.jpg";